/**
* Created by vouill on 1/3/18.
*/

<template>
  <div>
    <div class="v-content-container"><div class="v-title">{{ article.fields.title }}</div>
      <authors
        :includes="includes"
        :authors="article.fields.authors"
        :published-date="article.fields.publishedDate"
      />
      <div
        v-if="article.fields.tags && article.fields.tags.length > 0"
        class="tags-container">
        <span
          v-for="tag in article.fields.tags"
          class="tag is-info">{{ tag }}</span>
      </div>
      <div
        v-if="article.fields.youtubeVideoId"
        class="v-video-container">
        <iframe
          width="100%"
          height="315"
          :src="`https://www.youtube.com/embed/${article.fields.youtubeVideoId}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen/>
      </div>
      <div class="v-chapo"><VShowdown :source="article.fields.preview"/></div>
      <div class="content"><VShowdown :source="article.fields.content"/> </div>
      <div
        class="cta"
        v-if="!me && !article.fields.content">
        <div><router-link to="/identification">Identifiez</router-link> vous  pour pouvoir profiter de cet article !</div>
      </div>
</div></div></template>
<style scoped lang="scss">
.v-video-container {
  display: flex;
  margin-bottom: 1em;
}
.tags-container {
  margin-bottom: 1em;
}
.tag {
  margin-right: 1em;
}
img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.v-chapo {
  margin-bottom: 2em;
  font-size: 25px;
  font-weight: 500;
}

.v-content-container {
  max-width: 700px;
  font-family: "Roboto Slab";
}
.cta {
  text-align: center;
  button {
    margin-top: 1em;
  }
}

.v-title {
  font-family: "Roboto Slab";
  color: #ef6c00;

  font-size: 50px;
  margin-bottom: 0.5em;
}
.content {
  line-height: 1.5;
  font-family: "Roboto Slab";
  font-size: 17px;
  p {
    word-break: break-word;
  }
}

@media screen and (max-width: 400px) {
  .v-title {
    font-size: 30px;
  }
  .v-title,
  .v-chapo,
  .content {
    padding: 0 14px;
  }
}
</style>
<script>
import Authors from "./authors";
export default {
  name: "Article",
  props: { article: { type: Object }, includes: Object, me: Object },
  components: { Authors }
};
</script>
